export interface StepAnalytics {
    eventName?: string;
    isContext?: boolean;
    eventValue: string;
}

export interface ComponentAnalytics extends StepAnalytics {
    id?: string;
    componentId: AnalyticsComponents;
}

export interface Analytics {
    stepAnalytics: StepAnalytics,
    componentAnalytics: ComponentAnalytics[]
}

export enum AnalyticsComponents {
    AGREEMENT_CONFIRM,
    AGREEMENT_CANCEL,
    ASSIGN_CONFIRM,
    ASSIGN_CANCEL,
    ZK_MAX_LIMIT
}
